import { gql } from '@apollo/client'

export const Query = gql`
  query EditRowItem($companyId: ID!, $filters: RowItemFilters) {
    rowItems(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        priceCents
      }
    }
  }
`
